import { render, staticRenderFns } from "./SetDuration.vue?vue&type=template&id=f4459970&scoped=true&"
import script from "./SetDuration.vue?vue&type=script&lang=js&"
export * from "./SetDuration.vue?vue&type=script&lang=js&"
import style0 from "./SetDuration.vue?vue&type=style&index=0&id=f4459970&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4459970",
  null
  
)

export default component.exports